import React from 'react';
import {
    Box,
    Checkbox,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import { SearchRounded } from "@mui/icons-material";
import { getUserFixedName } from "../../../helper/utils";

const _PersonnelCustomSelector = ({
    searchPersonnel,
    setSearchPersonnel,
    selectedUsers,
    filteredPersonnel,
    handleSelectAllUsers,
    handleUserToggle,
    loadingPersonnel,
}) => {
    return (
        <Box sx={{ mt: 2.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 1.5 }}>
                <TextField
                    size="small"
                    placeholder="جستجوی نام، نام خانوادگی یا شماره همراه کارمند..."
                    value={searchPersonnel}
                    onChange={(e) => setSearchPersonnel(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchRounded sx={{ fontSize: 20, color: 'text.secondary' }} />
                            </InputAdornment>
                        ),
                    }}
                    sx={{ width: { xs: '100%', sm: 350 }, '& .MuiOutlinedInput-root': { borderRadius: 2.5 } }}
                />

                <Typography variant="body2" sx={{ fontWeight: 700, color: 'primary.main' }}>
                    {selectedUsers.length} نفر انتخاب شده‌اند
                </Typography>
            </Box>

            <TableContainer
                sx={{
                    maxHeight: 300,
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 2.5,
                }}
            >
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell padding="checkbox">
                                <Checkbox
                                    checked={filteredPersonnel.length > 0 && filteredPersonnel.every(u => selectedUsers.some(su => su.Id === u.Id))}
                                    indeterminate={
                                        filteredPersonnel.some(u => selectedUsers.some(su => su.Id === u.Id)) &&
                                        !filteredPersonnel.every(u => selectedUsers.some(su => su.Id === u.Id))
                                    }
                                    onChange={() => handleSelectAllUsers(filteredPersonnel)}
                                />
                            </TableCell>
                            <TableCell sx={{ fontWeight: 800 }}>نام کارمند</TableCell>
                            <TableCell sx={{ fontWeight: 800 }}>شماره همراه</TableCell>
                            <TableCell sx={{ fontWeight: 800 }}>کد ملی</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredPersonnel.map((person) => {
                            const isSelected = selectedUsers.some(u => u.Id === person.Id);
                            return (
                                <TableRow
                                    key={person.Id}
                                    hover
                                    onClick={() => handleUserToggle(person)}
                                    sx={{ cursor: 'pointer', bgcolor: isSelected ? 'action.selected' : 'inherit' }}
                                >
                                    <TableCell padding="checkbox">
                                        <Checkbox checked={isSelected} />
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}>{getUserFixedName(person?.User)}</TableCell>
                                    <TableCell>{person?.User?.PhoneNumber || "—"}</TableCell>
                                    <TableCell>{person?.User?.NationalCode || "—"}</TableCell>
                                </TableRow>
                            );
                        })}
                        {filteredPersonnel.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={4} align="center" sx={{ py: 3, color: 'text.secondary' }}>
                                    {loadingPersonnel ? "در حال دریافت لیست پرسنل..." : "کارمندی یافت نشد"}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default _PersonnelCustomSelector;
